import React, { Component } from "react";
import PropTypes from "prop-types";
import "../www/common.scss";
import "./contact.scss";
// import { Modal } from 'react-bootstrap';
const classnames = require("classnames");
const ContactContext = React.createContext();
const ContactProvider = ContactContext.Provider;
const ContactConsumer = ContactContext.Consumer;

class ContactComponent extends Component {
  constructor(props) {
    super(props);
    const self = this;
    self.renderWithContact = self.renderWithContact.bind(self);
  }
  renderWithContact() {
    throw new Error("method `renderWithContact` must be implemented");
  }
  render() {
    const self = this;
    return <ContactConsumer>{self.renderWithContact}</ContactConsumer>;
  }
}

export class ContactBlock extends ContactComponent {
  static propTypes = {
    className: PropTypes.string
  };
  renderWithContact({ readonly }) {
    const self = this;
    const className = classnames(
      "content-block",
      { "py-1": !readonly },
      self.props.className
    );
    return <div className={className}>{self.props.children}</div>;
  }
}

class ContactContentAnnotation extends Component {
  static propTypes = {
    strong: PropTypes.bool,
    important: PropTypes.bool,
    brackets: PropTypes.bool,
    bordered: PropTypes.bool,
    text: PropTypes.string.isRequired
  };
  render() {
    const self = this;
    const { strong, important, brackets, bordered, text } = self.props;
    const htmlText = brackets ? `【${text}】` : text;
    const classNames = ["d-inline-block", "mr-1"];
    if (strong) {
      classNames.push("text-dark", "font-weight-bold");
    }
    if (important) {
      classNames.push("text-danger", "font-weight-bold");
    }
    if (bordered) {
      classNames.push("px-1", "border", "text-nowrap", "bg-white");
      if (important) {
        classNames.push("border-danger");
      }
    }
    if (brackets) {
      classNames.push("brackets", "text-nowrap");
    }
    return <span className={classNames.join(" ")}>{htmlText}</span>;
  }
}

export class ContactDescription extends Component {
  static propTypes = {
    important: PropTypes.bool,
    example: PropTypes.bool,
    inline: PropTypes.bool
  };
  render() {
    const self = this;
    const classNames = ["small", "mb-0"];
    if (self.props.important) {
      classNames.push("text-danger", "font-weight-bold");
    }
    if (self.props.asterisked) {
      classNames.push("asterisked");
    }
    if (self.props.indented) {
      classNames.push("indented");
    }
    const Tag = self.props.inline ? "span" : "p";
    return (
      <Tag className={classNames.join(" ")}>
        {self.props.example && <span>例：</span>}
        {self.props.children}
      </Tag>
    );
  }
}

export class ContactContent extends ContactComponent {
  static propTypes = {
    required: PropTypes.bool,
    alphanum: PropTypes.bool,
    fullchar: PropTypes.bool,
    halfchar: PropTypes.bool,
    bottom: PropTypes.oneOf(["margin", "line", "none"]),
    caption: PropTypes.string,
    important: PropTypes.bool,
    annotations: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    ),
    alignItems: PropTypes.string,
    className: PropTypes.string
  };
  constructor(props) {
    super(props);
    const self = this;
    self.state = {
      annotationList: []
    };
  }
  componentDidMount() {
    const self = this;
    self.setAnnotationList(self.props);
  }
  componentDidUpdate() {
    const self = this;
    self.setAnnotationList(self.props);
  }
  setAnnotationList({
    required,
    alphanum,
    fullchar,
    halfchar,
    caption,
    annotations
  }) {
    const self = this;
    const annotationList = [];
    if (caption) {
      annotationList.push({
        important: Boolean(self.props.important),
        strong: true,
        text: caption
      });
    }
    if (required) {
      annotationList.push({
        important: true,
        bordered: true,
        text: "必須"
      });
    }
    if (alphanum) {
      annotationList.push({
        important: true,
        brackets: true,
        text: "半角英数"
      });
    }
    if (fullchar) {
      annotationList.push({
        important: true,
        brackets: true,
        text: "全角"
      });
    }
    if (halfchar) {
      annotationList.push({
        important: true,
        brackets: true,
        text: "半角"
      });
    }
    if (annotations) {
      Array.prototype.push.apply(annotationList, annotations);
    }
    if (
      JSON.stringify(annotationList) !==
      JSON.stringify(self.state.annotationList)
    ) {
      self.setState({ annotationList });
    }
  }
  renderWithContact({ readonly }) {
    const self = this;
    const annotationList = self.state.annotationList;
    const hasAnnotation = annotationList && annotationList.length >= 1;
    const bottomLine = self.props.bottom === "line";
    const className = classnames(
      "row",
      "contact-content",
      `align-items-${self.props.alignItems || "center"}`,
      self.props.className
    );
    return (
      <div>
        <div className={className}>
          {hasAnnotation && (
            <div
              className={classnames("col-12", "col-lg-3", "mb-lg-0", {
                "py-3": readonly
              })}
            >
              <div
                className={classnames("contact-content-note", {
                  "text-lg-right": readonly
                })}
              >
                {annotationList.map((annotation, i) => {
                  if (typeof annotation === "string") {
                    annotation = {
                      important: Boolean(self.props.important),
                      text: annotation
                    };
                  }
                  return (
                    <ContactContentAnnotation
                      key={`annotation-${i}`}
                      {...annotation}
                    />
                  );
                })}
              </div>
            </div>
          )}
          <div
            className={classnames("col-12", "col-lg-9", {
              "offset-lg-3": !hasAnnotation,
              "py-3": readonly,
              "align-self-stretch": readonly,
              "bg-white": readonly
            })}
          >
            <div className="contact-content-body">{self.props.children}</div>
          </div>
        </div>
        {bottomLine && (
          <div className="row contact-content-divider mb-1 align-items-center">
            <div className="col-12 col-lg-9 offset-lg-3">
              <hr />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export class ContactPanelHeader extends Component {
  render() {
    const self = this;
    return (
      <h2 className="h5 py-2 mb-0 text-center contact-panel-header">
        {self.props.children}
      </h2>
    );
  }
}

export class ContactPanelBody extends ContactComponent {
  static propTypes = {
    borderless: PropTypes.bool
  };
  renderWithContact({ readonly }) {
    const self = this;
    const borderless = self.props.borderless;
    const className = classnames("contact-panel-body", "container-fluid", {
      "py-2": !readonly,
      "border-bottom": !borderless,
      borderless: borderless
    });
    return <div className={className}>{self.props.children}</div>;
  }
}

export class ContactPanel extends Component {
  static propTypes = {
    title: PropTypes.string,
    theme: PropTypes.string,
    mb: PropTypes.number
  };
  static Header = ContactPanelHeader;
  static Body = ContactPanelBody;
  constructor(props) {
    super(props);
    const self = this;
    self.ref = React.createRef();
  }
  render() {
    const self = this;
    const theme = self.props.theme || "default";
    const children = self.props.children;
    const mb = self.props.mb != null ? self.props.mb : 3; // eslint-disable-line no-magic-numbers
    return (
      <div
        ref={self.ref}
        className={`contact-panel contact-panel-${theme} mb-${mb}`}
      >
        {self.props.title && (
          <ContactPanelHeader>{self.props.title}</ContactPanelHeader>
        )}
        {React.Children.map(children, (child, i) => {
          // 最後の要素であるPanelBodyは、ボーダーを消す
          const isLastBody =
            i === React.Children.count(children) - 1 &&
            child.type === ContactPanelBody;
          if (isLastBody) {
            return React.cloneElement(child, {
              borderless: true
            });
          }
          return child;
        })}
      </div>
    );
  }
}

class Contact extends Component {
  static propTypes = {
    theme: PropTypes.string,
    readonly: PropTypes.bool
  };
  static Panel = ContactPanel;
  static PanelBody = ContactPanelBody;
  static PanelHeader = ContactPanelHeader;
  static Block = ContactBlock;
  static Content = ContactContent;
  static Description = ContactDescription;
  render() {
    const self = this;
    const { theme = "default", readonly = false } = self.props;
    const contactProps = { theme, readonly };
    return (
      <div className={`contact contact-${theme}`}>
        <ContactProvider value={contactProps}>
          {self.props.children}
        </ContactProvider>
      </div>
    );
  }
}
export default Contact;
